import * as React from 'react';
import { ApSimpleDropdown } from '@alixpartners/ui-components';
import orderBy from 'lodash/orderBy';
import { TopJobRoles } from 'components/Tables/TopJobRoles';
import {
  SectionWrapper,
  HeaderLabel,
  TopDataContent,
  HeaderTop,
} from './Analysis.styles';
import { ApiContext } from 'context/ApiContext';
import {
  ICurrencyFormat,
  IDisplayByType,
  ITableRow,
  ITopJobRolesResponse,
} from 'utils/types';
import { DISPLAY_BY, DISPLAY_BY_TO_API } from 'utils/constants';
import { getDateLabels } from 'utils/format';
import { EXPORT_OPTIONS } from 'utils/constants';

const getTotal = (rowData: ITableRow[], field: string) => {
  return rowData.reduce((acc, row) => {
    return acc + (row[field] ? Number(row[field]) : 0);
  }, 0);
};

const TopJobRolesView = ({
  displayBy,
  downloadSpendHeadcountTableData,
  format,
  permanentContractorChecked,
  showSuccessNotification,
  topJobRoles,
}: {
  displayBy: IDisplayByType;
  downloadSpendHeadcountTableData: (s: string) => Promise<any>;
  format: ICurrencyFormat;
  permanentContractorChecked?: boolean;
  showSuccessNotification: () => void;
  topJobRoles?: ITopJobRolesResponse;
}) => {
  if (!topJobRoles) {
    return null;
  }
  const isHeadcount = displayBy === DISPLAY_BY.HEADCOUNT;

  const rowData = orderBy(topJobRoles.table, 'total', 'desc').map((item) => {
    return {
      title: item.clientRole,
      serviceTower: item.apSpendCategoryL1,
      businessUnit: item.businessUnit,
      expenseType: item.expenseType,
      location: item.location,
      permanentCount: item.permanentCount,
      contractorCount: item.contractorCount,
      totalCurrYear: isHeadcount ? item.count : item.cost,
      totalPrevYear: isHeadcount ? item.previousCount : item.previousCost,
      totalChange: isHeadcount
        ? item.count - Number(item.previousCount)
        : item.cost - Number(item.previousCost),
    };
  });
  const totalRow = {
    title: 'Total',
    serviceTower: '',
    businessUnit: '',
    expenseType: '',
    location: '',
    permanentCount: undefined,
    contractorCount: undefined,
    totalCurrYear: getTotal(rowData, 'totalCurrYear'),
    totalPrevYear: getTotal(rowData, 'totalPrevYear'),
    totalChange: getTotal(rowData, 'totalChange'),
  };
  const columnDateLabels = getDateLabels(
    topJobRoles.range,
    topJobRoles.comparisonRange
  );
  const headerPrefix = {
    [DISPLAY_BY.COST]: 'Cost',
    [DISPLAY_BY.PERCENTAGE_OF_REVENUE]: 'Cost',
    [DISPLAY_BY.HEADCOUNT]: 'Headcount',
  }[displayBy];

  return (
    <SectionWrapper>
      <HeaderTop>
        <HeaderLabel>Top Personnel Job Roles by {headerPrefix}</HeaderLabel>
        <ApSimpleDropdown
          iconName="outline_save_alt"
          onChange={(opt: any) => {
            if (opt.value === 'xlsx') {
              downloadSpendHeadcountTableData(
                DISPLAY_BY_TO_API[displayBy]
              ).then(showSuccessNotification);
            }
          }}
          options={[EXPORT_OPTIONS[1]]}
          label="Export"
        />
      </HeaderTop>
      <TopDataContent>
        <TopJobRoles
          columnDateLabels={columnDateLabels}
          format={format}
          isHeadcount={isHeadcount}
          permanentContractorChecked={permanentContractorChecked}
          rowData={rowData}
          totalRow={totalRow}
        />
      </TopDataContent>
    </SectionWrapper>
  );
};

export default (props: any) => (
  <ApiContext.Consumer>
    {({ format }) => <TopJobRolesView {...props} format={format} />}
  </ApiContext.Consumer>
);
